import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { LINK_BOOKING_AI_AGENT } from 'shared/constants/links'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export const AlertCalendlyFreePlan = observer(() => {
  const { integrationsStore } = useEntitiesContext()
  const calendlyIntegrationStateStore = integrationsStore.calendlyIntegrationStateStore

  if (calendlyIntegrationStateStore.calendlyStatus === 'free')
    return (
      <div className={styles.wrap}>
        <Alert
          item={{
            type: 'warning',
            desc: 'For best results, use a paid Calendly account. Free plans don’t confirm bookings to the AI Agent',
          }}
          actions={[
            {
              variant: 'link',
              type: 'primary',
              text: 'Learn more',
              link: LINK_BOOKING_AI_AGENT,
            },
          ]}
          marginInline={-4}
        />
      </div>
    )

  return null
})
